module.exports = __webpack_public_path__ + "img/29.ca34e908.jpg";